export const scrollToRef = (elem:any, style:any, unit:any, from:any, to:any, time:any, prop:any, cb?:()=>void) => {
  if (!elem) {
    return;
  }
  var start = new Date().getTime(),
    timer = setInterval(function() {
      var step = Math.min(1, (new Date().getTime() - start) / time);
      // console.log("called",start,step);
      if (prop) {
        elem[style] = (from + step * (to - from)) + unit;
      } else {
        elem.style[style] = (from + step * (to - from)) + unit;
      }
      if (step === 1) {
        clearInterval(timer);
        if( typeof cb === "function"){
          cb()
        }
      }
    }, 1);
  if (prop) {
    elem[style] = from + unit;
  } else {
    elem.style[style] = from + unit;
  }
}
